
<div *ngIf="card" class="btn-track chip d-inline-block px-3 py-1" (click)="openMarketPlace()">
    <div class="d-flex flex-row align-items-center">
        <img class="picto-medium" src="../../../assets/images/231116/pictos/Box-arrow-in-up-right.svg" />
        <div class="typo-chip ms-2">{{ 'wap1_c_marketplace_go' | translate }}</div>
    </div>
</div>